export default (function (value) {
  if (typeof value !== 'object' || value === null) return false;
  var proto = value;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(value) === proto;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-blueprint/~/redux-actions/es/utils/isPlainObject.js
// module id = 181
// module chunks = 1